<div [class]="cssClassSuffix ? 'container next-offer next-offer--' + cssClassSuffix : 'container next-offer'"
    [ngClass]="{'next-offer--recommended': cssClassSuffix}">

    <div *ngIf="recommendationRoleConfig"
        class="next-offer__recommendation">
        {{ recommendationConfig.title | translate }}
    </div>

    <div class="next-offer__left">
        <ng-container *ngTemplateOutlet="logo"></ng-container>
        <ng-container *ngTemplateOutlet="compareButton"></ng-container>
    </div>

    <div class="next-offer__right">
        <div class="next-offer__right__top">
            <div class="next-offer__right__top__left">
                <ng-container *ngTemplateOutlet="logo"></ng-container>
                <ng-container *ngTemplateOutlet="primaryCoverages"></ng-container>
                <ng-container *ngTemplateOutlet="detailCoverages"></ng-container>
                <ng-container *ngTemplateOutlet="detailsBtn"></ng-container>
            </div>
            <div class="next-offer__right__top__right">
                <ng-container *ngTemplateOutlet="price"></ng-container>
                <ng-container *ngTemplateOutlet="detailsBtn"></ng-container>
            </div>
        </div>

        <div class="next-offer__right__bottom">
            <ng-container *ngTemplateOutlet="primaryCoverages"></ng-container>
            <ng-container *ngTemplateOutlet="detailCoverages"></ng-container>
            <ng-container *ngTemplateOutlet="compareButton"></ng-container>
            <ng-container *ngTemplateOutlet="buyOnline"></ng-container>
        </div>
    </div>

</div>

<ng-template #logo>
    <div class="next-offer__logo">
        <img class="next-offer__logo__img"
             [src]="logoUrl"
             alt="">
    </div>
</ng-template>

<ng-template #compareButton>
    <div *ngIf="comparingOffersAllowed"
         class="next-offer__compare-btn">
        <mat-checkbox #compareCheckbox
                      [checked]="compareCheckboxChecked"
                      [disabled]="!addOfferToComparisonAllowed && !compareCheckboxChecked"
                      (change)="changeCompareCheckbox()">
                    <span class="next-offer__compare-btn__checkbox-label"
                          (click)="compareOffers($event)">
                        <img class="next-offer__compare-btn__icon"
                             [src]="compareIconSrc">
                        <span>{{ compareButtonLabel | translate }}
                            <ng-container *ngIf="compareCheckboxChecked">
                                ({{ comparisonOffersAmount }})
                            </ng-container>
                        </span>
                    </span>
        </mat-checkbox>
    </div>
</ng-template>

<ng-template #primaryCoverages>
    <div class="next-offer__primary-coverages">
        <ng-container *ngFor="let primaryBox of primaryBoxes">
            <app-offer-primary-box
                    *ngIf="canShowBox(primaryBox.options, primaryBox.selectedOption, primaryBox.enabled)"
                    class="next-offer__primary-coverage offer-primary-box"
                    [box]="primaryBox">
            </app-offer-primary-box>
        </ng-container>
    </div>
</ng-template>

<ng-template #detailCoverages>
    <div *ngIf="anyDetailCoverages" class="next-offer__detail-coverages">
        <div *ngFor="let group of detailCoverageGroupBoxes"
             [class]="'next-offer__detail-coverages__group next-offer__detail-coverages__group--' + group.groupCode">
            <ng-container *ngFor="let box of group.boxes">
                <app-next-offer-detail-box class="next-offer__detail-coverages__box"
                                           [ngClass]="{'next-offer__detail-coverages__box--mobile-hidden': !offerCoveragesService.isBoxVisibleOnMobile(group, box.coverageCode)}"
                                           *ngIf="canShowBox(box.options, box.selectedOption, box.enabled)"
                                           [box]="box">
                </app-next-offer-detail-box>
            </ng-container>
        </div>
    </div>
</ng-template>

<ng-template #detailsBtn>
    <div class="next-offer__details-btn">
        <button (click)="showOfferDetails()"
                class="btn btn--clear-arrow">
            <span class="next-offer__details-btn__caption--desktop">{{ 'OFFER_SECTION.offerDetails' | translate }}</span>
            <span class="next-offer__details-btn__caption--mobile">{{ 'OFFER_SECTION.details' | translate }}</span>
            <span class="material-icons">{{ detailsButtonIcon }}</span>
        </button>
    </div>
</ng-template>

<ng-template #buyOnline>
    <div class="next-offer__buy-online">
        <button class="btn btn--secondary btn--small-padding buy-online"
                (click)="selectOffer()">
            {{buyOnlineButtonLabel | translate}}
        </button>
    </div>
</ng-template>

<ng-template #price>
    <div class="next-offer__price">
        <app-offer-fixed-price [offer]="offer"></app-offer-fixed-price>
    </div>
</ng-template>
